import React, { useEffect, useRef } from "react";
import { useToast } from "../Toast/ToastProvider";
import { useSpace } from "../../Contexts/SpaceContext";
import dayjs from "dayjs";
import { useCurrentAccount } from "../../Contexts/UserContext";
import { isDeveloper } from "../../Helpers/ModulesHelper";

const DevOpsExpirerValidador = ({ children }) => {
  const alreadyRanOnce = useRef(false);
  const createToast = useToast();
  const space = useSpace();
  const thisAccount = useCurrentAccount();

  const developer = isDeveloper(thisAccount);
  useEffect(() => {
    if (!alreadyRanOnce.current && space.DevOpsExpiredAt && developer) {
      alreadyRanOnce.current = true;
      const givenDate = dayjs(space.DevOpsExpiredAt).startOf("day");
      const today = dayjs().startOf("day");
      const diffDays = givenDate.diff(today, "day");

      if (diffDays >= 0 && diffDays <= 3) {
        createToast({
          pos: "tm",
          type: "warning",
          title: "Chave DevOps expira em poucos dias",
          description: "Por favor insira uma nova chave PAT nos settings",
        });
      }
    }
  }, [createToast, developer, space.DevOpsExpiredAt]);

  return <>{children}</>;
};

export default DevOpsExpirerValidador;
